import { createFileRoute } from "@tanstack/react-router";
import { parseStatsSearch } from "@/components/stats/logic";
import { StatsPage } from "@/components/stats/stats-page";

export const Route = createFileRoute("/_app/$workspaceSlug/stats")({
  // How far back and whose live in the URL, so a view can be shared. Anything
  // the page does not know is the default: eight weeks, the reader's own.
  validateSearch: parseStatsSearch,
  component: StatsRoute,
});

function StatsRoute() {
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <StatsPage
      key={workspaceSlug}
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
    />
  );
}
